import type {
  CustomerSnapshot,
  SupportTask,
} from "../types/supportTasks.types";

/** Keep every client-side support-task search surface in parity. */
export const matchesSupportTaskSearch = (
  task: Pick<SupportTask, "external_task_id" | "customer_snapshot" | "tags"> & {
    agent?: { name?: string | null } | null;
  },
  query: string,
): boolean => {
  const needle = query.trim().toLowerCase();
  if (!needle) {
    return true;
  }
  const snapshot = task.customer_snapshot as CustomerSnapshot;
  return Boolean(
    task.external_task_id?.toLowerCase().includes(needle) ||
      snapshot?.name?.toLowerCase().includes(needle) ||
      snapshot?.email?.toLowerCase().includes(needle) ||
      snapshot?.phone?.toLowerCase().includes(needle) ||
      snapshot?.member_id?.toLowerCase().includes(needle) ||
      snapshot?.tags?.some((tag: string) =>
        tag.toLowerCase().includes(needle),
      ) ||
      task.tags?.some((tag: string) => tag.toLowerCase().includes(needle)) ||
      task.agent?.name?.toLowerCase().includes(needle),
  );
};
